import pdfIcon from '../assets/pdf.png'
import docxIcon from '../assets/docx.png'

/** Extensões aceitas pelo document-analyzer (backend responde 415 para as demais). */
export const ANALYZER_ACCEPTED_EXTENSIONS = '.pdf,.docx,.doc'

const WORD_EXTENSIONS = ['doc', 'docx']

export const getFileExtension = (fileNameOrUrl?: string | null): string => {
    if (!fileNameOrUrl) return ''
    const sanitized = fileNameOrUrl.split('?')[0].toLowerCase()
    return sanitized.includes('.') ? sanitized.split('.').pop() ?? '' : ''
}

/** Só existem ícones de PDF e Word; os demais formatos usam o genérico (pdf). */
export const getAnalyzerFileIcon = (fileNameOrUrl?: string | null): string =>
    WORD_EXTENSIONS.includes(getFileExtension(fileNameOrUrl))
        ? docxIcon
        : pdfIcon
